export const tagValues = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']
